import { render, staticRenderFns } from "./manageHotels.vue?vue&type=template&id=716c7f47"
import script from "./manageHotels.vue?vue&type=script&lang=js"
export * from "./manageHotels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports